import React, { useState } from "react";
import { useSelector } from "react-redux";
import AttributesComponent from './attributes.component';
import {AccessRights} from "lib/constants/accessRights"
import {canAccess} from "../../../profile/redux/selector/profile.selector";

function AttributesContainer(){
  const [ isCreateDialogOpen, setIsCreateDialogOpen ] = useState(false)

  const handleCreateAtrribute = (value) => {
    setIsCreateDialogOpen(value)
  }
  const lang = useSelector(state => state.constant.languages);
  const hasProductAttributeAddAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Product.ATTRIBUTE_CREATE)
  );

  return (
    <>
      <AttributesComponent
        hasProductAttributeAddAccessRight={hasProductAttributeAddAccessRight}
        handleCreateAttribute={handleCreateAtrribute}
        isCreateDialogOpen={isCreateDialogOpen}
        lang={lang}
      /> 
    </>
  )
}

export default AttributesContainer
